// \uC778\uBCF4\uC774\uC2A4 PDF/xlsx \uB2E4\uC6B4\uB85C\uB4DC \uC751\uB2F5\uC5D0\uC11C X-Invoice-Signature \uD5E4\uB354 \uCCB4\uD06C
// 4-state: ok-cid-{N} / missing-file-cid-{N} / no-folder-cid-{N} / invalid-cid
// ok- \uC774\uC678\uC758 \uAC12\uC774\uBA74 \uC5C5\uCCB4 \uC11C\uBA85 \uBBF8\uC124\uC815 \u2192 \uAC1D\uBC15 (showToast \uD638\uCD9C)
//
// \uC0AC\uC6A9:
//   authFetch(API+'/invoices/123/pdf').then(function(r){
//     checkSignatureStatus(r, showToast);
//     return r.blob();
//   })
//
// Phase 1.5 #5 — 2026-04-19

function checkSignatureStatus(response, showToast) {
  try {
    var sig = (response && response.headers && response.headers.get('X-Invoice-Signature')) || '';
    // \uBE48 \uBB38\uC790\uC5F4 or 'ok-' \uC73C\uB85C \uC2DC\uC791 \u2192 \uC815\uC0C1 (\uACBD\uACE0 \uC5C6\uC74C)
    if (!sig || sig.indexOf('ok-') === 0) return response;
    // missing-file / no-folder / invalid \u2192 \uAC1D\uBC15 \uD45C\uC2DC
    if (typeof showToast === 'function') {
      showToast('\u26A0\uFE0F \uC5C5\uCCB4 \uC11C\uBA85 \uBBF8\uC124\uC815 \u2014 \uC124\uC815 > \uC11C\uBA85\uC5D0\uC11C \uC5C5\uB85C\uB4DC\uD574\uC8FC\uC138\uC694', 'err');
    }
  } catch (e) { /* \uD5E4\uB354 \uC811\uADFC \uC2E4\uD328\uB294 \uBB34\uD574\uD654 (\uB2E4\uC6B4\uB85C\uB4DC \uC790\uCCB4\uB294 \uC815\uC0C1 \uC9C4\uD589) */ }
  return response;
}

export { checkSignatureStatus };
